/**
 * 组织设置 API 服务
 */
import { api, API_PATHS } from './client';

// 组织设置
export interface OrgSettingsData {
  id: string;
  name: string;
  logo: string;
  banner: string;
  primaryColor: string;
  secondaryColor: string;
  welcomeMessage: string;
  createdAt: string;
  updatedAt: string;
}

// 更新设置请求
export interface UpdateSettingsRequest {
  name?: string;
  logo?: string;
  banner?: string;
  primaryColor?: string;
  secondaryColor?: string;
  welcomeMessage?: string;
}

/**
 * 获取组织设置
 */
export async function getSettings(): Promise<OrgSettingsData> {
  return api.get<OrgSettingsData>(API_PATHS.SETTINGS);
}

/**
 * 更新组织设置
 */
export async function updateSettings(data: UpdateSettingsRequest): Promise<void> {
  await api.put<null>(API_PATHS.SETTINGS, data);
}
